import { render, staticRenderFns } from "./video-detail.vue?vue&type=template&id=0341d644&scoped=true"
import script from "./video-detail.vue?vue&type=script&lang=js"
export * from "./video-detail.vue?vue&type=script&lang=js"
import style0 from "./video-detail.vue?vue&type=style&index=0&id=0341d644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0341d644",
  null
  
)

export default component.exports